export const BUYMATERIAL = "/";
export const LOGIN = "/login";
export const OTP = "/verify";
export const SELECT = "/usertype";
export const PROFILE = "/profile";
export const INFO = "/profile/info";
export const ORDERS = "/profile/orders";
export const RFQ = "/profile/rfq";
export const NOTFOUND = "/404";